import React from "react";

const Divider = () => {
  return <div className="divider mt-5 mb-5"></div>;
};

export default Divider;
